import config from 'config'
import { BillingInventory } from 'models'
import { fleetview } from '../fleetview'
import { buildQueryString } from 'utils'
import { QueryOptions, ListResult, ReadResult } from 'interfaces/queryOptions'

export async function list(
  options: QueryOptions
): Promise<ListResult<BillingInventory>> {
  options.count = options.count ?? true
  options.limit = options.limit ?? config.items_per_list_page

  const optionString = buildQueryString(options)

  const response = await fleetview.get(`/v5/billing/inventories${optionString}`)
  return response.data
}

export async function showFreeBillingInventory(
  options: Pick<QueryOptions, 'attributes' | 'includes' | 'filters'> = {}
): Promise<ReadResult<BillingInventory> | undefined> {
  const optionString = buildQueryString(options)

  const response = await fleetview.get(`/v5/billing/inventories${optionString}`)

  if (response.data.data.length === 0) return undefined

  return response.data.data[0]
}

export async function createBatch(
  inventoryInformations: Record<string, any>
): Promise<ListResult<BillingInventory>> {
  const registersResult = await fleetview.post('/v5/billing/inventories', {
    data: inventoryInformations
  })
  return registersResult.data
}
